import React, { useState, useEffect } from "react";
import S from "../styles";

export default function UndoToast({ message, onUndo, onExpire, duration = 30 }) {
  const [remaining, setRemaining] = useState(duration);

  useEffect(() => {
    const t = setInterval(() => {
      setRemaining((r) => {
        if (r <= 1) {
          clearInterval(t);
          onExpire();
          return 0;
        }
        return r - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={S.toast}>
      <span style={{ fontSize: 15, color: "#0A0A0F" }}>{message}</span>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <span style={{ fontSize: 14, color: "rgba(10,10,15,0.58)", fontFamily: "'JetBrains Mono', monospace" }}>
          {remaining}s
        </span>
        <button onClick={onUndo} style={S.undoBtn}>
          Undo
        </button>
      </div>
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          height: 3,
          background: "#0033FF",
          borderRadius: 0,
          transition: "width 1s linear",
          width: `${(remaining / duration) * 100}%`,
        }}
      />
    </div>
  );
}
